import React from 'react';
import { styled } from '@mui/material/styles';
import { STAR_SIZE_MEDIUM, StarRatingComponent } from '../../../../common/StarRating';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CommentOutlined, InfoOutlined } from '@mui/icons-material';
import { formatDecimal } from '@lialo/core/lib/utils/formatter/numberFormatter';
import classNames from 'classnames';

const PREFIX = 'AverageTourRating';

const classes = {
  root: `${PREFIX}-root`,
  starContainer: `${PREFIX}-starContainer`,
  ratingsAverageCount: `${PREFIX}-ratingsAverageCount`,
  totalRatings: `${PREFIX}-totalRatings`,
  comments: `${PREFIX}-comments`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.root}`]: {
    margin: 0,
  },

  [`& .${classes.starContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.ratingsAverageCount}`]: {
    paddingBottom: theme.spacing(0.75),
    marginLeft: theme.spacing(1.5),
  },

  [`& .${classes.comments}`]: {
    display: 'flex',
    marginLeft: theme.spacing(0.5),
    color: theme.palette.grey[600],
  },
}));

interface IProps {
  value: number;
  totalRatings: number;
  numberOfComments?: number;
  className?: string;
  starSize?: number;
}

export const AverageTourRating = (props: IProps) => {
  const { t } = useTranslation();
  return (
    <StyledBox className={classNames(classes.root, props.className)}>
      <Box className={classes.starContainer}>
        <StarRatingComponent readOnly={true} value={props.value} starSize={props.starSize ?? STAR_SIZE_MEDIUM} />
        <Typography className={classes.ratingsAverageCount} variant={'subtitle2'} component={'span'}>
          {formatDecimal(props.value)}
        </Typography>
        <Typography className={classes.ratingsAverageCount} variant={'body2'}>
          {t('tour_detail.reviews.totalRatings', { count: props.totalRatings })}
        </Typography>
      </Box>
      {props.numberOfComments !== undefined && (
        <Box m={1} display={'flex'} alignItems={'center'} className={classes.comments}>
          <CommentOutlined sx={{ mr: 1 }} fontSize={'small'} />
          <Typography variant={'body2'}>
            {t('tour_detail.reviews.subtitle', { count: props.numberOfComments })}
          </Typography>
          <Tooltip enterTouchDelay={0} title={t('tour_detail.reviews.tooltip')}>
            <IconButton size={'small'}>
              <InfoOutlined sx={{width: 20, height: 20}} />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </StyledBox>
  );
};
